import { AsideConfig } from '../../../configuration'

export const asideConfig: AsideConfig = {
  disabledOptions: new Set(['Incidents timeline', 'Statistics']),
}
